import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { Flex } from "../../../../styled-system/jsx";
import { Select } from "../../../components/fields/base/Select";
import { Switch } from "../../../components/fields/base/Switch";
import { useAgencies } from "../../admin/api/useAgencies";

const AgencyFilter = ({
  show,
  value,
  onToggle,
  onChange,
}: {
  show: boolean;
  value: number | "none";
  onToggle: (v: boolean) => void;
  onChange: (v: number | "none") => void;
}) => {
  const { t } = useTranslation(["user_management"]);
  const agencyOptionsQuery = useAgencies();

  const agencyOptions = useMemo(() => {
    const noAgencyLabel = t(($) => $.user_management["No Agency Selected"]);
    if (!agencyOptionsQuery.data) {
      return [{ label: noAgencyLabel, value: "none" }];
    }

    return [
      { label: noAgencyLabel, value: "none" },
      ...agencyOptionsQuery.data.results.map((agency) => ({
        label: agency.name,
        value: agency.id,
      })),
    ];
  }, [agencyOptionsQuery.data, t]);

  return (
    <Flex gap={"large"} paddingY={"large"}>
      <Switch isSelected={show} onChange={onToggle}>
        {t(($) => $.user_management["Show Agency Filter"])}
      </Switch>
      {show && (
        <Select
          items={agencyOptions}
          selectedKey={value}
          onSelectionChange={(v) => (v === "none" ? onChange("none") : onChange(Number(v)))}
          css={{ width: "250px" }}
        />
      )}
    </Flex>
  );
};

export default AgencyFilter;
